import {
  BACK_TO_CHECKOUT_TAB,
  PRIMARY_BUTTON,
  SECONDARY_BUTTON
} from './result.const';
import { ResultLayout, SuccessIllustration } from './ResultLayout';
import { useCountdownEnd } from './useCountdownEnd';

interface PaymentMethodAddedProps {
  /** Counts down to `onCountdownEnd`; without it the page waits for the visitor. */
  countdownSeconds?: number;
  onCountdownEnd?: () => void;
  /** Shows a "Back to checkout" button. */
  onBackToCheckout?: () => void;
  /** With no way back to a checkout: a "Go to AyeFace home" button. */
  onGoHome?: () => void;
}

export function PaymentMethodAdded({
  countdownSeconds,
  onCountdownEnd,
  onBackToCheckout,
  onGoHome
}: Readonly<PaymentMethodAddedProps>) {
  const counting = countdownSeconds !== undefined;
  const remaining = useCountdownEnd(
    countdownSeconds ?? 0,
    counting,
    onCountdownEnd
  );

  return (
    <ResultLayout>
      <SuccessIllustration alt="Payment method added" />

      <h1 className="mt-6 text-center text-2xl font-bold text-gray-900">
        Payment method added
      </h1>
      <p className="mt-2 text-center text-sm text-gray-500">
        {counting ? `Back to checkout in ${remaining}s` : BACK_TO_CHECKOUT_TAB}
      </p>

      {onBackToCheckout && (
        <button
          type="button"
          onClick={onBackToCheckout}
          className={`mt-8 ${PRIMARY_BUTTON}`}
        >
          Back to checkout
        </button>
      )}
      {onGoHome && (
        <button
          type="button"
          onClick={onGoHome}
          className={`mt-8 ${SECONDARY_BUTTON}`}
        >
          Go to AyeFace home
        </button>
      )}
    </ResultLayout>
  );
}
